/** @format */

module.exports = {
  enableNonHashControls: false,
  enablePreloading: true,
};



// WEBPACK FOOTER //
// ./src/partners/config/loader.js